import React from 'react';
import {ajax, resolveRoute} from '../../helpers/ajax'
import css from './insights.less';
import PieChart from './PieChart';
import YearControl from './YearControl';
import TripMonthTable from './TripMonthTable';

type State = any;

export default class TripMonthData extends React.PureComponent<{}, State> {

    state = {data: null};

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        ajax(resolveRoute('reports.insights.tripMonth'), {
            queryParams: {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'year' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                year: this.props.year
            }
        }).then((res: any) => {
            if (res.ok) {
                this.setState({data: res.data});
            }
        });
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'year' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        if (prevProps.year !== this.props.year) {
            this.refresh();
        }
    }

    render() {
        const {data} = this.state;

        return (
            <div>
                {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'changeYear' does not exist on type 'Read... Remove this comment to see the full error message */}
                <YearControl changeYear={this.props.changeYear} year={this.props.year}/>
                <div className={css.sideBySide}>
                    <div style={{flex: 1, minWidth: '360px'}}>
                        <TripMonthTable data={data}/>
                    </div>
                    <div style={{flex: 2, minWidth: '300px'}}>
                        {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'null' is not assignable to type 'any[] | und... Remove this comment to see the full error message */}
                        <PieChart data={data} labelKey="monthName" valueKey="count" width={300} height={300}/>
                    </div>
                </div>
            </div>
        )
    }
}
